import { handleActions } from 'redux-actions';
import { apiModuleDefaultState, createApiActions } from './helpers';

export const actions = createApiActions('profile');

const reducer = handleActions(
  {
    [actions.api.profile.request]: () => ({
      isFetching: true,
      isError: false,
    }),
    [actions.api.profile.response]: (_, { payload }) => ({
      isFetching: false,
      isError: false,
      data: payload,
    }),
    [actions.api.profile.error]: (_, { payload }) => ({
      isFetching: false,
      isError: true,
      error: payload,
    }),
  },
  { ...apiModuleDefaultState, data: {}, error: null }
);

export default reducer;
